import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { User } from '../icons';

const LoginButton = props => {
  const {
    location: { pathname },
    handleOpenLoginModal
  } = props;

  if (pathname === '/login') {
    return null;
  }

  return (
    <Fragment>
      <button
        className="header-button__link header-button__link--login"
        type="button"
        onClick={handleOpenLoginModal}
      >
        <User width="32" height="32" viewBox="0 0 32 32" />
        <span className="header-button--account-label">Log In</span>
      </button>
    </Fragment>
  );
};

LoginButton.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  handleOpenLoginModal: PropTypes.func.isRequired
};

export default LoginButton;
